export default "__VITE_ASSET__mgWZLrhc__"